// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schichtplan-container {
  max-width: 1400px;
}

.schichtplan-container > .back-arrow {
  position: static !important;
  top: auto !important;
  left: auto !important;
  width: max-content;
  margin: 0 0 0.6rem;
  padding-left: 0;
  transform: none !important;
}

.schichtplan-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.schichtplan-head .section-title {
  margin-bottom: 1rem;
}

.dienst-editor-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.2rem;
}

.logistik-import-btn.compact,
.logistik-print-link.compact {
  min-height: auto;
  padding: 0.45rem 0.7rem;
}

.schicht-matrix-wrapper {
  width: 100%;
  overflow: auto;
  max-height: calc(100vh - 260px);
  border-radius: 12px;
  background: var(--hellgruen);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}

.schicht-matrix {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Circular', sans-serif;
}

.schicht-matrix th,
.schicht-matrix td {
  border: none;
}

.schicht-matrix thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: var(--logistik);
  color: var(--blassgruen);
  padding: 0.7rem 0.65rem;
  text-align: left;
}

.time-header,
.time-cell {
  position: sticky;
  left: 0;
  z-index: 5;
  width: 4.25rem;
  min-width: 4.25rem;
}

.time-header {
  background: var(--logistik) !important;
}

.time-cell {
  background: var(--hellgruen);
  color: var(--dunkelgruen);
  font-family: 'Staatliches', sans-serif;
  font-size: 1rem;
  font-weight: normal;
  text-align: center;
  padding: 0.35rem 0.45rem;
  vertical-align: top;
}

.schicht-matrix tbody tr:nth-child(even) .time-cell,
.schicht-matrix tbody tr:nth-child(even) .matrix-cell {
  background: var(--blassgruen);
}

.task-header {
  width: 11rem;
  min-width: 11rem;
  max-width: 11rem;
  vertical-align: top;
}

.dienst-header-editor {
  position: relative;
  display: grid;
  gap: 0.3rem;
}

.dienst-title-input,
.dienst-soll-input,
.dienst-desc-input {
  width: 100%;
  min-height: auto;
  border: none;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.72rem;
  padding: 0.28rem 0.35rem;
}

.dienst-title-input {
  font-family: 'Staatliches', sans-serif;
  font-size: 0.95rem;
  text-transform: uppercase;
}

.dienst-desc-input {
  resize: vertical;
  line-height: 1.2;
}

.dienst-scope-toggle {
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.16);
  color: var(--blassgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.66rem;
  line-height: 1.15;
  padding: 0.25rem 0.3rem;
  text-transform: none;
}

.dienst-scope-toggle input[type="checkbox"] {
  flex: 0 0 auto;
  width: 0.85rem;
  height: 0.85rem;
  margin: 0.02rem 0 0;
  accent-color: var(--logistik-hell);
}

.dienst-scope-toggle span {
  overflow-wrap: anywhere;
}

.dienst-delete-btn {
  justify-self: end;
  min-height: auto !important;
  padding: 0.2rem 0.35rem !important;
  border-radius: 7px !important;
  background: var(--blutorange) !important;
  color: var(--weiss) !important;
}

.dienst-delete-btn .material-symbols-outlined {
  color: inherit !important;
  font-size: 0.95rem !important;
}

.task-name,
.task-soll,
.task-description {
  display: block;
  color: inherit;
}

.task-name {
  font-family: 'Staatliches', sans-serif;
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 1.05;
}

.task-soll {
  margin-top: 0.2rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.72rem;
}

.task-description {
  margin-top: 0.2rem;
  font-family: 'Circular', sans-serif;
  font-size: 0.68rem;
  line-height: 1.2;
}

.matrix-cell {
  width: 11rem;
  min-width: 11rem;
  max-width: 11rem;
  height: 2.5rem;
  vertical-align: top;
  background: rgba(180, 200, 130, 0.3);
  border-left: 1px solid rgba(100, 130, 2, 0.12);
  border-top: 1px solid rgba(100, 130, 2, 0.12);
}

.matrix-cell.filled {
  background: var(--logistik-blass) !important;
}

.matrix-cell.continued {
  background: rgba(224, 244, 246, 0.78) !important;
}

.matrix-cell.regular {
  box-shadow: inset 3px 0 0 var(--logistik);
}

.matrix-cell-button {
  position: relative;
  width: 100%;
  min-height: 2.5rem !important;
  height: 100%;
  padding: 0.35rem 0.45rem !important;
  border-radius: 0 !important;
  background: transparent !important;
  border: none !important;
  color: var(--dunkelgruen) !important;
  cursor: pointer;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "person regular"
    "time regular";
  gap: 0.35rem;
  font-family: 'Circular', sans-serif !important;
  text-transform: none !important;
  text-align: left;
  line-height: 1.2;
  white-space: pre-line;
}

.matrix-cell-button:disabled {
  cursor: default;
  opacity: 1;
}

.matrix-cell-button:hover {
  background: rgba(224, 244, 246, 0.85) !important;
}

.cell-person {
  grid-area: person;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.8rem;
  overflow-wrap: anywhere;
}

.cell-time-range {
  grid-area: time;
  color: var(--logistik);
  font-family: 'Circular', sans-serif;
  font-size: 0.68rem;
  line-height: 1.15;
  white-space: pre-line;
}

.cell-empty {
  color: transparent;
  font-size: 1rem;
  line-height: 1;
}

.matrix-cell-button:hover .cell-empty {
  color: var(--logistik);
}

.cell-regular {
  grid-area: regular;
  color: var(--logistik);
  font-size: 1rem;
  line-height: 1;
  flex-shrink: 0;
}

.cell-continuation {
  grid-column: 1 / -1;
  width: 100%;
  min-height: 1.7rem;
  border-left: 2px solid var(--logistik);
  opacity: 0.45;
}

.cell-resize-handle {
  position: absolute;
  left: 0.45rem;
  right: 0.45rem;
  bottom: 0.12rem;
  height: 0.35rem;
  border-radius: 999px;
  background: var(--logistik);
  opacity: 0.45;
  cursor: ns-resize;
  touch-action: none;
}

.cell-resize-handle:hover {
  opacity: 0.9;
}

.cell-editor {
  background: var(--weiss);
  border: 2px solid var(--logistik);
  border-radius: 8px;
  padding: 0.45rem;
  min-width: 14rem;
  position: relative;
  z-index: 6;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);
}

.cell-editor-text {
  width: 100%;
  min-height: 4rem;
  resize: vertical;
  border: none;
  border-radius: 5px;
  background: rgba(180, 200, 130, 0.5);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.9rem;
  padding: 0.45rem;
}

.cell-editor-meta {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.5rem;
  align-items: start;
  margin-top: 0.45rem;
}

.cell-editor-meta label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--logistik);
  font-family: 'Staatliches', sans-serif;
  font-size: 0.9rem;
}

.cell-editor-meta input[type="time"] {
  width: 5.5rem;
  min-height: auto;
  border: none;
  border-radius: 5px;
  background: rgba(180, 200, 130, 0.5);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  padding: 0.3rem;
}

.repeat-day-picker {
  min-width: 0;
}

.repeat-day-label {
  display: block;
  color: var(--logistik);
  font-family: 'Staatliches', sans-serif;
  font-size: 0.9rem;
  line-height: 1;
  margin-bottom: 0.28rem;
}

.repeat-day-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.repeat-day-chip {
  min-height: auto !important;
  border: 1px solid rgba(0, 107, 117, 0.28) !important;
  border-radius: 999px !important;
  background: rgba(224, 244, 246, 0.6) !important;
  color: var(--logistik) !important;
  font-family: 'Circular', sans-serif !important;
  font-size: 0.68rem !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  padding: 0.32rem 0.42rem !important;
  text-transform: none !important;
}

.repeat-day-chip.active {
  background: var(--logistik) !important;
  border-color: var(--logistik) !important;
  color: var(--weiss) !important;
}

.repeat-day-chip.locked {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);
}

.cell-editor-actions {
  display: flex;
  gap: 0.3rem;
  margin-top: 0.45rem;
}

.matrix-icon-btn {
  min-height: auto !important;
  padding: 0.25rem 0.45rem !important;
  border-radius: 8px !important;
  font-size: 0.85rem !important;
}

.matrix-icon-btn .material-symbols-outlined {
  font-size: 1rem !important;
  color: inherit !important;
}

.matrix-icon-btn.save {
  background: var(--logistik) !important;
  color: var(--weiss) !important;
}

.matrix-icon-btn.cancel {
  background: var(--logistik-hell) !important;
  color: var(--logistik) !important;
}

.matrix-icon-btn.delete {
  margin-left: auto;
  background: var(--blutorange) !important;
  color: var(--weiss) !important;
}

.schichtplan-container .logistik-print-link,
.schichtplan-container .logistik-print-link .print-text,
.schichtplan-container .logistik-print-link .material-symbols-outlined {
  color: var(--logistik) !important;
}

.dienst-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(72, 80, 40, 0.55);
  backdrop-filter: blur(2px);
}

.dienst-confirm-dialog {
  width: min(100%, 31rem);
  border-radius: 24px;
  background: var(--weiss);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
  padding: 2.4rem;
  text-align: center;
}

.dienst-confirm-dialog h2 {
  margin: 0 0 0.75rem;
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  font-size: 2.15rem;
  font-weight: normal;
  line-height: 1;
}

.dienst-confirm-dialog p {
  margin: 0;
  color: var(--mittelblau);
  font-family: 'Circular', sans-serif;
  font-size: 1.05rem;
  line-height: 1.45;
}

.dienst-confirm-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 1.6rem;
}

.dienst-confirm-buttons button {
  min-height: auto !important;
  border: none !important;
  border-radius: 999px !important;
  padding: 0.75rem 1.35rem !important;
  color: var(--weiss) !important;
  font-family: 'Circular', sans-serif !important;
  font-size: 0.98rem !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);
}

.dienst-confirm-no {
  background: var(--orange) !important;
}

.dienst-confirm-yes {
  background: var(--blutorange) !important;
}

.schicht-print-table {
  width: 100%;
  border-collapse: collapse;
}

@media print {
  @page {
    size: A4 landscape;
    margin: 7mm;
  }

  .kernteam-navbar,
  .back-arrow,
  .schichtplan-head,
  .logistik-tabs,
  .logistik-footer,
  .schicht-matrix-wrapper,
  .dienst-confirm-overlay {
    display: none !important;
  }

  .kernteam-layout-content,
  .schichtplan-container {
    margin: 0 !important;
    padding: 0 !important;
  }

  .schichtplan-container {
    max-width: none;
    padding: 0;
  }

  .schicht-print-table.only-print {
    display: table !important;
  }

  .schicht-print-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-family: Arial, sans-serif !important;
    font-size: 5.4pt;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .schicht-print-table thead {
    display: table-header-group;
  }

  .schicht-print-table th,
  .schicht-print-table td {
    border: 0.6pt solid #1f2f2f !important;
    padding: 1.1pt 1.5pt !important;
    vertical-align: top;
    font-family: Arial, sans-serif !important;
    color: #111 !important;
    background: #fff !important;
  }

  .print-day-title {
    color: #005f68 !important;
    font-family: Arial, sans-serif !important;
    font-size: 12pt !important;
    font-weight: bold !important;
    margin-bottom: 3.5mm !important;
    text-transform: none !important;
  }

  .print-time-header,
  .print-time-cell {
    width: 10mm;
    text-align: center;
    white-space: nowrap;
  }

  .print-task-header {
    height: 11mm;
    background: #005f68 !important;
  }

  .print-task-header .task-name,
  .print-task-header .task-soll,
  .print-task-header .task-description {
    display: block;
    color: #fff !important;
    font-family: Arial, sans-serif !important;
    text-transform: none !important;
  }

  .print-task-header .task-name {
    font-size: 5.8pt !important;
    font-weight: bold !important;
    line-height: 1.02;
  }

  .print-task-header .task-soll,
  .print-task-header .task-description {
    margin-top: 0.7pt;
    font-size: 4.4pt !important;
    line-height: 1.02;
  }

  .print-time-cell {
    background: #eef3df !important;
    font-size: 5.1pt !important;
    font-weight: bold !important;
  }

  .print-matrix-cell {
    height: 2.35mm;
    min-height: 2.35mm;
  }

  .print-matrix-cell.filled {
    background: #d6edf0 !important;
  }

  .print-matrix-cell.regular {
    box-shadow: inset 1.4pt 0 0 #005f68 !important;
  }

  .print-cell-person,
  .print-cell-time {
    display: block;
    white-space: pre-line;
    overflow-wrap: anywhere;
    font-family: Arial, sans-serif !important;
  }

  .print-cell-person {
    font-size: 5.2pt !important;
    font-weight: bold !important;
    line-height: 1.04;
  }

  .print-cell-time {
    margin-top: 0.6pt;
    color: #004f58 !important;
    font-size: 4.4pt !important;
    line-height: 1;
  }
}

@media (max-width: 800px) {
  .schichtplan-head {
    display: block;
  }

  .dienst-editor-actions {
    justify-content: flex-start;
    margin-bottom: 0.75rem;
  }

  .schicht-matrix-wrapper {
    max-height: calc(100vh - 220px);
  }

  .task-header,
  .matrix-cell {
    width: 9.5rem;
    min-width: 9.5rem;
    max-width: 9.5rem;
  }

  .cell-editor {
    min-width: 12rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/logistik/schichtplan/Schichtplan.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;EAC7B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C;;kBAEgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,+BAA+B;EAC/B,+CAA+C;EAC/C,iCAAiC;EACjC,8CAA8C;EAC9C,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,8BAA8B;EAC9B,8CAA8C;EAC9C,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,sCAAsC;IACtC,+BAA+B;IAC/B,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,yCAAyC;IACzC,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;IAC/B,+BAA+B;EACjC;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;;;IAGE,cAAc;IACd,sBAAsB;IACtB,yCAAyC;IACzC,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;;IAEE,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".schichtplan-container {\n  max-width: 1400px;\n}\n\n.schichtplan-container > .back-arrow {\n  position: static !important;\n  top: auto !important;\n  left: auto !important;\n  width: max-content;\n  margin: 0 0 0.6rem;\n  padding-left: 0;\n  transform: none !important;\n}\n\n.schichtplan-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.schichtplan-head .section-title {\n  margin-bottom: 1rem;\n}\n\n.dienst-editor-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-top: 0.2rem;\n}\n\n.logistik-import-btn.compact,\n.logistik-print-link.compact {\n  min-height: auto;\n  padding: 0.45rem 0.7rem;\n}\n\n.schicht-matrix-wrapper {\n  width: 100%;\n  overflow: auto;\n  max-height: calc(100vh - 260px);\n  border-radius: 12px;\n  background: var(--hellgruen);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n}\n\n.schicht-matrix {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-family: 'Circular', sans-serif;\n}\n\n.schicht-matrix th,\n.schicht-matrix td {\n  border: none;\n}\n\n.schicht-matrix thead th {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  background: var(--logistik);\n  color: var(--blassgruen);\n  padding: 0.7rem 0.65rem;\n  text-align: left;\n}\n\n.time-header,\n.time-cell {\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  width: 4.25rem;\n  min-width: 4.25rem;\n}\n\n.time-header {\n  background: var(--logistik) !important;\n}\n\n.time-cell {\n  background: var(--hellgruen);\n  color: var(--dunkelgruen);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1rem;\n  font-weight: normal;\n  text-align: center;\n  padding: 0.35rem 0.45rem;\n  vertical-align: top;\n}\n\n.schicht-matrix tbody tr:nth-child(even) .time-cell,\n.schicht-matrix tbody tr:nth-child(even) .matrix-cell {\n  background: var(--blassgruen);\n}\n\n.task-header {\n  width: 11rem;\n  min-width: 11rem;\n  max-width: 11rem;\n  vertical-align: top;\n}\n\n.dienst-header-editor {\n  position: relative;\n  display: grid;\n  gap: 0.3rem;\n}\n\n.dienst-title-input,\n.dienst-soll-input,\n.dienst-desc-input {\n  width: 100%;\n  min-height: auto;\n  border: none;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.92);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.72rem;\n  padding: 0.28rem 0.35rem;\n}\n\n.dienst-title-input {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n}\n\n.dienst-desc-input {\n  resize: vertical;\n  line-height: 1.2;\n}\n\n.dienst-scope-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.3rem;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.16);\n  color: var(--blassgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.66rem;\n  line-height: 1.15;\n  padding: 0.25rem 0.3rem;\n  text-transform: none;\n}\n\n.dienst-scope-toggle input[type=\"checkbox\"] {\n  flex: 0 0 auto;\n  width: 0.85rem;\n  height: 0.85rem;\n  margin: 0.02rem 0 0;\n  accent-color: var(--logistik-hell);\n}\n\n.dienst-scope-toggle span {\n  overflow-wrap: anywhere;\n}\n\n.dienst-delete-btn {\n  justify-self: end;\n  min-height: auto !important;\n  padding: 0.2rem 0.35rem !important;\n  border-radius: 7px !important;\n  background: var(--blutorange) !important;\n  color: var(--weiss) !important;\n}\n\n.dienst-delete-btn .material-symbols-outlined {\n  color: inherit !important;\n  font-size: 0.95rem !important;\n}\n\n.task-name,\n.task-soll,\n.task-description {\n  display: block;\n  color: inherit;\n}\n\n.task-name {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1rem;\n  text-transform: uppercase;\n  line-height: 1.05;\n}\n\n.task-soll {\n  margin-top: 0.2rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.72rem;\n}\n\n.task-description {\n  margin-top: 0.2rem;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.68rem;\n  line-height: 1.2;\n}\n\n.matrix-cell {\n  width: 11rem;\n  min-width: 11rem;\n  max-width: 11rem;\n  height: 2.5rem;\n  vertical-align: top;\n  background: rgba(180, 200, 130, 0.3);\n  border-left: 1px solid rgba(100, 130, 2, 0.12);\n  border-top: 1px solid rgba(100, 130, 2, 0.12);\n}\n\n.matrix-cell.filled {\n  background: var(--logistik-blass) !important;\n}\n\n.matrix-cell.continued {\n  background: rgba(224, 244, 246, 0.78) !important;\n}\n\n.matrix-cell.regular {\n  box-shadow: inset 3px 0 0 var(--logistik);\n}\n\n.matrix-cell-button {\n  position: relative;\n  width: 100%;\n  min-height: 2.5rem !important;\n  height: 100%;\n  padding: 0.35rem 0.45rem !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  border: none !important;\n  color: var(--dunkelgruen) !important;\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"person regular\"\n    \"time regular\";\n  gap: 0.35rem;\n  font-family: 'Circular', sans-serif !important;\n  text-transform: none !important;\n  text-align: left;\n  line-height: 1.2;\n  white-space: pre-line;\n}\n\n.matrix-cell-button:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.matrix-cell-button:hover {\n  background: rgba(224, 244, 246, 0.85) !important;\n}\n\n.cell-person {\n  grid-area: person;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.8rem;\n  overflow-wrap: anywhere;\n}\n\n.cell-time-range {\n  grid-area: time;\n  color: var(--logistik);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.68rem;\n  line-height: 1.15;\n  white-space: pre-line;\n}\n\n.cell-empty {\n  color: transparent;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.matrix-cell-button:hover .cell-empty {\n  color: var(--logistik);\n}\n\n.cell-regular {\n  grid-area: regular;\n  color: var(--logistik);\n  font-size: 1rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.cell-continuation {\n  grid-column: 1 / -1;\n  width: 100%;\n  min-height: 1.7rem;\n  border-left: 2px solid var(--logistik);\n  opacity: 0.45;\n}\n\n.cell-resize-handle {\n  position: absolute;\n  left: 0.45rem;\n  right: 0.45rem;\n  bottom: 0.12rem;\n  height: 0.35rem;\n  border-radius: 999px;\n  background: var(--logistik);\n  opacity: 0.45;\n  cursor: ns-resize;\n  touch-action: none;\n}\n\n.cell-resize-handle:hover {\n  opacity: 0.9;\n}\n\n.cell-editor {\n  background: var(--weiss);\n  border: 2px solid var(--logistik);\n  border-radius: 8px;\n  padding: 0.45rem;\n  min-width: 14rem;\n  position: relative;\n  z-index: 6;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);\n}\n\n.cell-editor-text {\n  width: 100%;\n  min-height: 4rem;\n  resize: vertical;\n  border: none;\n  border-radius: 5px;\n  background: rgba(180, 200, 130, 0.5);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9rem;\n  padding: 0.45rem;\n}\n\n.cell-editor-meta {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.5rem;\n  align-items: start;\n  margin-top: 0.45rem;\n}\n\n.cell-editor-meta label {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: var(--logistik);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 0.9rem;\n}\n\n.cell-editor-meta input[type=\"time\"] {\n  width: 5.5rem;\n  min-height: auto;\n  border: none;\n  border-radius: 5px;\n  background: rgba(180, 200, 130, 0.5);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  padding: 0.3rem;\n}\n\n.repeat-day-picker {\n  min-width: 0;\n}\n\n.repeat-day-label {\n  display: block;\n  color: var(--logistik);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 0.9rem;\n  line-height: 1;\n  margin-bottom: 0.28rem;\n}\n\n.repeat-day-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n.repeat-day-chip {\n  min-height: auto !important;\n  border: 1px solid rgba(0, 107, 117, 0.28) !important;\n  border-radius: 999px !important;\n  background: rgba(224, 244, 246, 0.6) !important;\n  color: var(--logistik) !important;\n  font-family: 'Circular', sans-serif !important;\n  font-size: 0.68rem !important;\n  font-weight: 700 !important;\n  line-height: 1 !important;\n  padding: 0.32rem 0.42rem !important;\n  text-transform: none !important;\n}\n\n.repeat-day-chip.active {\n  background: var(--logistik) !important;\n  border-color: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.repeat-day-chip.locked {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.6);\n}\n\n.cell-editor-actions {\n  display: flex;\n  gap: 0.3rem;\n  margin-top: 0.45rem;\n}\n\n.matrix-icon-btn {\n  min-height: auto !important;\n  padding: 0.25rem 0.45rem !important;\n  border-radius: 8px !important;\n  font-size: 0.85rem !important;\n}\n\n.matrix-icon-btn .material-symbols-outlined {\n  font-size: 1rem !important;\n  color: inherit !important;\n}\n\n.matrix-icon-btn.save {\n  background: var(--logistik) !important;\n  color: var(--weiss) !important;\n}\n\n.matrix-icon-btn.cancel {\n  background: var(--logistik-hell) !important;\n  color: var(--logistik) !important;\n}\n\n.matrix-icon-btn.delete {\n  margin-left: auto;\n  background: var(--blutorange) !important;\n  color: var(--weiss) !important;\n}\n\n.schichtplan-container .logistik-print-link,\n.schichtplan-container .logistik-print-link .print-text,\n.schichtplan-container .logistik-print-link .material-symbols-outlined {\n  color: var(--logistik) !important;\n}\n\n.dienst-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(72, 80, 40, 0.55);\n  backdrop-filter: blur(2px);\n}\n\n.dienst-confirm-dialog {\n  width: min(100%, 31rem);\n  border-radius: 24px;\n  background: var(--weiss);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);\n  padding: 2.4rem;\n  text-align: center;\n}\n\n.dienst-confirm-dialog h2 {\n  margin: 0 0 0.75rem;\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  font-size: 2.15rem;\n  font-weight: normal;\n  line-height: 1;\n}\n\n.dienst-confirm-dialog p {\n  margin: 0;\n  color: var(--mittelblau);\n  font-family: 'Circular', sans-serif;\n  font-size: 1.05rem;\n  line-height: 1.45;\n}\n\n.dienst-confirm-buttons {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n  margin-top: 1.6rem;\n}\n\n.dienst-confirm-buttons button {\n  min-height: auto !important;\n  border: none !important;\n  border-radius: 999px !important;\n  padding: 0.75rem 1.35rem !important;\n  color: var(--weiss) !important;\n  font-family: 'Circular', sans-serif !important;\n  font-size: 0.98rem !important;\n  font-weight: 700 !important;\n  text-transform: none !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);\n}\n\n.dienst-confirm-no {\n  background: var(--orange) !important;\n}\n\n.dienst-confirm-yes {\n  background: var(--blutorange) !important;\n}\n\n.schicht-print-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n@media print {\n  @page {\n    size: A4 landscape;\n    margin: 7mm;\n  }\n\n  .kernteam-navbar,\n  .back-arrow,\n  .schichtplan-head,\n  .logistik-tabs,\n  .logistik-footer,\n  .schicht-matrix-wrapper,\n  .dienst-confirm-overlay {\n    display: none !important;\n  }\n\n  .kernteam-layout-content,\n  .schichtplan-container {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .schichtplan-container {\n    max-width: none;\n    padding: 0;\n  }\n\n  .schicht-print-table.only-print {\n    display: table !important;\n  }\n\n  .schicht-print-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n    font-family: Arial, sans-serif !important;\n    font-size: 5.4pt;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .schicht-print-table thead {\n    display: table-header-group;\n  }\n\n  .schicht-print-table th,\n  .schicht-print-table td {\n    border: 0.6pt solid #1f2f2f !important;\n    padding: 1.1pt 1.5pt !important;\n    vertical-align: top;\n    font-family: Arial, sans-serif !important;\n    color: #111 !important;\n    background: #fff !important;\n  }\n\n  .print-day-title {\n    color: #005f68 !important;\n    font-family: Arial, sans-serif !important;\n    font-size: 12pt !important;\n    font-weight: bold !important;\n    margin-bottom: 3.5mm !important;\n    text-transform: none !important;\n  }\n\n  .print-time-header,\n  .print-time-cell {\n    width: 10mm;\n    text-align: center;\n    white-space: nowrap;\n  }\n\n  .print-task-header {\n    height: 11mm;\n    background: #005f68 !important;\n  }\n\n  .print-task-header .task-name,\n  .print-task-header .task-soll,\n  .print-task-header .task-description {\n    display: block;\n    color: #fff !important;\n    font-family: Arial, sans-serif !important;\n    text-transform: none !important;\n  }\n\n  .print-task-header .task-name {\n    font-size: 5.8pt !important;\n    font-weight: bold !important;\n    line-height: 1.02;\n  }\n\n  .print-task-header .task-soll,\n  .print-task-header .task-description {\n    margin-top: 0.7pt;\n    font-size: 4.4pt !important;\n    line-height: 1.02;\n  }\n\n  .print-time-cell {\n    background: #eef3df !important;\n    font-size: 5.1pt !important;\n    font-weight: bold !important;\n  }\n\n  .print-matrix-cell {\n    height: 2.35mm;\n    min-height: 2.35mm;\n  }\n\n  .print-matrix-cell.filled {\n    background: #d6edf0 !important;\n  }\n\n  .print-matrix-cell.regular {\n    box-shadow: inset 1.4pt 0 0 #005f68 !important;\n  }\n\n  .print-cell-person,\n  .print-cell-time {\n    display: block;\n    white-space: pre-line;\n    overflow-wrap: anywhere;\n    font-family: Arial, sans-serif !important;\n  }\n\n  .print-cell-person {\n    font-size: 5.2pt !important;\n    font-weight: bold !important;\n    line-height: 1.04;\n  }\n\n  .print-cell-time {\n    margin-top: 0.6pt;\n    color: #004f58 !important;\n    font-size: 4.4pt !important;\n    line-height: 1;\n  }\n}\n\n@media (max-width: 800px) {\n  .schichtplan-head {\n    display: block;\n  }\n\n  .dienst-editor-actions {\n    justify-content: flex-start;\n    margin-bottom: 0.75rem;\n  }\n\n  .schicht-matrix-wrapper {\n    max-height: calc(100vh - 220px);\n  }\n\n  .task-header,\n  .matrix-cell {\n    width: 9.5rem;\n    min-width: 9.5rem;\n    max-width: 9.5rem;\n  }\n\n  .cell-editor {\n    min-width: 12rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
